import React,{useEffect, useRef,useContext} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import Button from '@mui/material/Button';
import Design from '../CV/Design';
import {Sabko} from '../App';

import '../style/result.css';


function Result() {
  const navigate=useNavigate();
  const {state}=useContext(Sabko);

  const location=useLocation();
  
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    useEffect(()=>{
      if(!state.User?.Personal){
        navigate('/personal');
      }else{
        handlePrint();
      }
    },[handlePrint])
  return (
    <>
    <div className='main'>
    <Button id='mainButt' variant="contained" onClick={()=>navigate('/')}>Home</Button>

    <div style={{display:'none'}}>
    <div  className='resultdivc' ref={componentRef}>
      {    (location.state==="Design")&&(<Design />)
      }     
    </div>
    </div>

    </ div>

    </>
    )
}

export default Result